import { saKaznom } from "./kazneIznosi";
import { uZonu, izZone } from "./vreme";
/* Noćna vožnja — prekršaj ako vožnja u noćnom periodu pređe dozvoljeni limit.
 *
 * ISPRAVLJENO (07.08.2026): raniji obračun je davao lažne prekršaje jer je
 *   - sabirao CELO trajanje vožnje i kad samo deo pada u noć,
 *   - dodavao fiksne blokove (+1h, +3h) na osnovu sata početka/kraja,
 *   - duplo brojao istu vožnju (dva uslova su se okidala za isti zapis),
 *   - kod odmora koji se ZAVRŠAVA u noćnom periodu radio `continue`, pa se
 *     akumulator nikad nije resetovao i prenosio se na pogrešan dan.
 * Sada se računa STVARNI presek intervala vožnje sa noćnim prozorom, po danu.
 */

const NIGHT_START_H = 0;   // noćni period: 00:00 ...
const NIGHT_END_H   = 4;   // ... do 04:00 (Zakon o radnom vremenu posade vozila)
const LIMIT_MS      = 3 * 60 * 60 * 1000;   // dozvoljeno najviše 3h noćne vožnje

export function processRecordsNightDriving(records, company, driversDB) {
    const findDriver = (id) => {
        const driver = driversDB.find(d => d.Id === id);
        return driver ? driver.FullName : '';
    };

    const formatTime = (ms) => {
        const hours = String(Math.floor(ms / (60 * 60 * 1000))).padStart(2, '0');
        const minutes = String(Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000))).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const dayKey = (d) => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;

    const formatSRBTime = (key) => {
        const [y, m, d] = String(key).split('-');
        return `${d}.${m}.${y}`;
    };

    const arrayNightDriving = [];
    let count = 0;

    for (const driver of driversDB) {
        const filtered = records.filter(item => item.DriverId === driver.Id);

        // presek vožnje sa noćnim prozorom, akumulirano po danu
        const perDay = {};

        for (const record of filtered) {
            if (!record.Value || record.Value.toLowerCase() !== 'driving') continue;
            /* Noćni prozor 00:00–04:00 je po ZIDNOM SATU (čl. 40), ne po UTC-u.
               Zato se oba kraja prvo prebace u zonu, pa i dani i prozor ispadnu
               lokalni. Prekršaj se na kraju vraća u pravi UTC — zonu primenjuje
               prikaz, i to samo jednom. */
            const start = uZonu(new Date(record.StartTime).getTime());
            const end = uZonu(new Date(record.EndTime).getTime());
            if (!isFinite(start) || !isFinite(end) || end <= start) continue;

            // prođi kroz sve kalendarske dane koje interval dodiruje (vožnja može preći ponoć)
            const firstDay = new Date(start);
            firstDay.setUTCHours(0, 0, 0, 0);
            for (let t = firstDay.getTime(); t <= end; t += 24 * 60 * 60 * 1000) {
                const winStart = t + NIGHT_START_H * 60 * 60 * 1000;
                const winEnd = t + NIGHT_END_H * 60 * 60 * 1000;
                const overlap = Math.min(end, winEnd) - Math.max(start, winStart);
                if (overlap > 0) {
                    const key = dayKey(new Date(t));
                    perDay[key] = (perDay[key] || 0) + overlap;
                }
            }
        }

        for (const key of Object.keys(perDay).sort()) {
            if (perDay[key] > LIMIT_MS) {
                count++;
                /* Interval prekršaja = noćni prozor tog dana — dijagram ga boji,
                   a tabela prikazuje trajanje i prekoračenje. */
                const dan = Date.parse(`${key}T00:00:00.000Z`);
                /* nazad u stvarni UTC — ponoć i 04:00 nikad ne padaju u dvoznačni
                   sat prelaska na zimsko vreme, pa je pretvaranje jednoznačno */
                const od = izZone(dan + NIGHT_START_H * 60 * 60 * 1000);
                const doo = izZone(dan + NIGHT_END_H * 60 * 60 * 1000);
                arrayNightDriving.push({
                    Prekršaj: count,
                    Vozač: findDriver(driver.Id),
                    Kompanija: company.Name,
                    Poruka: saKaznom(`Prekršaj dana ${formatSRBTime(key)}: prekoračena noćna vožnja (dozvoljeno najviše ${formatTime(LIMIT_MS)} u periodu ${String(NIGHT_START_H).padStart(2, '0')}:00–${String(NIGHT_END_H).padStart(2, '0')}:00). Noćna vožnja ${formatTime(perDay[key])}!`, 3),
                    Pocetak: new Date(od).toISOString(),
                    Kraj: new Date(doo).toISOString(),
                    Vreme: new Date(doo).toISOString(),
                    Tip: 'Noćna vožnja',
                    Podtip: `${String(NIGHT_START_H).padStart(2, '0')}:00–${String(NIGHT_END_H).padStart(2, '0')}:00`,
                    Trajanje: perDay[key],
                    Prekoracenje: perDay[key] - LIMIT_MS,
                    Nivo: 3,
                });
            }
        }
    }

    return arrayNightDriving;
}
